import UIText from '@components/ui/UIText'
import { Box, Skeleton } from '@mui/joy'
import { theme } from '@ui/style'
import { pxToRem } from '@ui/style/muiTheme'
import { uuidv4 } from '@utils/random'
import { rankStyle } from './AsideArticlesItem'

type Props = {
	length?: number
	hasRanking?: boolean
}
const AsideArticlesItemSkeleton = ({ length = 5, hasRanking = false }: Props) => {
	const skeletonArray = new Array(length).fill(null)

	return (
		<Box
			display={{ sm: 'flex', md: 'none', lg: 'flex' }}
			flexDirection={{ xs: 'column', md: 'row', lg: 'column' }}
			sx={{
				'& > div': { width: '100%' },
				'&>*:not(:first-child)': {
					marginTop: {
						xs: pxToRem(16),
						md: 0,
						lg: pxToRem(16),
					},
					marginLeft: {
						md: pxToRem(16),
						lg: 0,
					},
				},
			}}
			className="asideArticlesItemSkeleton"
		>
			{hasRanking && <UIText sx={{ ...rankStyle }} />}
			{skeletonArray.map(() => (
				<Box key={uuidv4()} sx={{ borderTop: `solid 1px ${theme.color.colGray3}` }}>
					<Skeleton
						variant="rectangular"
						width="100%"
						height={{ sm: 68, md: 74 }}
						sx={{ marginTop: pxToRem(16) }}
					/>
				</Box>
			))}
		</Box>
	)
}

export default AsideArticlesItemSkeleton
